import * as React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { defaultFontStack } from "../../../../styles/typography/v2";
const Root = styled.span(defaultFontStack, () => {
  return { fontSize: 25, fontWeight: 300 };
});

function IconListItem(props) {
  const { className, children, style } = props;
  return (
    <Root className={className} style={{ color: style?.textColor }}>
      {children}
    </Root>
  );
}

IconListItem.propTypes = {
  className: PropTypes.string,
  style: PropTypes.shape({
    textColor: PropTypes.string,
  }),
  children: PropTypes.node.isRequired,
};

export default IconListItem;
